import React, { useEffect, useState } from "react";
import { Form, Field } from "react-final-form";
import "../styles/ConsultarTramite.css";
import { getConsultPeople } from "../services/consultProcedure/consultProcedure";
import { getSurveyVerificationPeople } from "../services/consultProcedure/consultProcedure";
import { Link } from "react-router-dom";
import { encode as base64_encode } from "base-64";
import { getEnvVariables } from "../utils/helpers/getEnvVariables";

const { API_URL, SATISFACTION_SURVEY, SURVEY } = getEnvVariables();

const ConsultarTramite = () => {
    const [show, setShow] = useState(false);
    const [data, setData] = useState(null);
    const [showSurvey, setShowSurvey] = useState(false);
    const [urlSurvey, setUrlSurvey] = useState(null);

    let last_step = 0;
    let id_solicitud = 0;
    let texto = [];

    const onSubmit = async (values) => {
        try {
            const response = await getConsultPeople(
                values.numeroDeDocumento,
                values.fechaExpedicionDocumento
            );
            if (response.length > 0) {
                last_step = response[0]?.solicitud[0]?.paso_solicitud.id;
                id_solicitud = response[0]?.solicitud[0]?.id;
                if (response[0]?.datos_devolucion) {
                    texto = response[0]?.datos_devolucion.map(
                        (x) => x.causal_devolucion.nombre_documento
                    );
                }

                const solicitud = response.map((x) => {
                    const datos = x.datos_notas
                        ?.sort(
                            (a, b) =>
                                new Date(b.fecha_nota) - new Date(a.fecha_nota)
                        )
                        ?.shift();
                    return {
                        ...x,
                        datos_archivos: Object.values(
                            x.datos_archivos
                                .filter((x) => x.tipo_archivo.estado == 1)
                                ?.reduce((acc, file) => {
                                    const tipoCodigo = file.tipo_archivo.id;

                                    if (!acc[tipoCodigo]) {
                                        acc[tipoCodigo] = file;
                                    } else {
                                        if (
                                            new Date(file.fecha_carga) >
                                            new Date(
                                                acc[tipoCodigo].fecha_carga
                                            )
                                        ) {
                                            acc[tipoCodigo] = file;
                                        }
                                    }

                                    return acc;
                                }, {})
                        ),
                        datos_nota: {
                            ...datos,
                            observacion: datos?.observacion
                                ?.replace(/\r\n\r\n/g, "<br /><br /><br />")
                                ?.replace(/\r\n/g, "<br /><br />"),
                        },
                    };
                });

                setData(solicitud[0]);
                setShow(true);

                if (response[0]?.contacto.length > 0) {
                    const uuid = response[0]?.contacto[0]?.uuid;
                    setUrlSurvey(`${SATISFACTION_SURVEY}${SURVEY}&idt=${uuid}`)
                    if (uuid) {
                        try {
                            const responseVerification =
                                await getSurveyVerificationPeople(uuid);
                            if (!responseVerification?.estado) {
                                setShowSurvey(true);
                            }
                        } catch (error) {
                            setShowSurvey(true);
                            console.log('Error al consultar la encuesta', error);
                        }
                    } else {
                        setShowSurvey(true);
                    }
                } else {
                    setShowSurvey(true);
                }

                localStorage.setItem("persona_id", response[0].id);
                localStorage.setItem(
                    "ultimo_paso",
                    response[0]?.solicitud[0].estado_solicitud.nombre ===
                        "CREADA"
                        ? ++last_step
                        : last_step
                );
                localStorage.setItem("documento", response[0].numero_documento);
                localStorage.setItem("id_solicitud", id_solicitud);
                localStorage.setItem(
                    "estado",
                    response[0]?.solicitud[0].estado_solicitud.nombre
                );
            } else {
                setShow(true);
                setData(undefined);
            }
        } catch (error) {
            setShow(true);
            setData(undefined);
        }
    };

    useEffect(() => localStorage.clear(), []);

    return (
        <div className="App">
            <govco-header
                ishome="true"
                isbeta="false"
                usuario=""
                fixed="false"
                auth_active="false"
                search_active="false"
            ></govco-header>
            <govco-accesibility-bar></govco-accesibility-bar>
            <govco-back-to-top></govco-back-to-top>
            <div className="container">
                <div className="row">
                    <div className="col-12"></div>
                    <div className="col-lg-8 mt-5">
                        <h2>Consulta estado del trámite y/o servicio BEPS</h2>
                        <Form
                            onSubmit={onSubmit}
                            validate={(values) => {
                                const errors = {};
                                if (!values.numeroDeDocumento) {
                                    errors.numeroDeDocumento =
                                        "Este campo es requerido";
                                }
                                if (!values.fechaExpedicionDocumento) {
                                    errors.fechaExpedicionDocumento =
                                        "Este campo es requerido";
                                }

                                return errors;
                            }}
                            render={({
                                handleSubmit,
                                form,
                                submitting,
                                pristine,
                                values,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Field name="numeroDeDocumento">
                                                {({ input, meta }) => (
                                                    <div className="form-group gov-co-form-group w-100">
                                                        <label>
                                                            Numero de Documento:
                                                            *
                                                        </label>
                                                        <input
                                                            {...input}
                                                            type="text"
                                                            className={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "w-100 invalid"
                                                                    : "w-100"
                                                            }
                                                        />
                                                        <small className="error-message form-text">
                                                            {meta.error &&
                                                                meta.touched && (
                                                                    <span>
                                                                        {
                                                                            meta.error
                                                                        }
                                                                    </span>
                                                                )}
                                                        </small>
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="col-lg-6">
                                            <Field name="fechaExpedicionDocumento">
                                                {({ input, meta }) => (
                                                    <div className="form-group gov-co-form-group w-100">
                                                        <label>
                                                            Fecha expedición
                                                            Documento: *
                                                        </label>
                                                        <input
                                                            {...input}
                                                            type="date"
                                                            className={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "w-100 invalid"
                                                                    : "w-100"
                                                            }
                                                        />
                                                        <small className="error-message form-text">
                                                            {meta.error &&
                                                                meta.touched && (
                                                                    <span>
                                                                        {
                                                                            meta.error
                                                                        }
                                                                    </span>
                                                                )}
                                                        </small>
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="col content-bottoms">
                                            <Link to={`/`}>
                                                <button className="btn btn-round btn-high">
                                                    Salir
                                                </button>
                                            </Link>
                                            <button
                                                type="submit"
                                                disabled={submitting}
                                                className="btn btn-round btn-high boton-inicio"
                                            >
                                                Consultar
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        />

                        {show && data !== undefined ? (
                            <>
                                {showSurvey ? (
                                    <div className="p-4 d-flex justify-content-center">
                                        <Link to={urlSurvey} target="_blank">
                                            <button className="btn btn-round btn-high mt-1">
                                                ENCUESTA DE SATISFACCIÓN
                                            </button>
                                        </Link>
                                    </div>
                                ) : (
                                    ""
                                )}
                                <table className="table mt-4">
                                    <thead>
                                        <tr>
                                            <th scope="col">Nombre</th>
                                            <th scope="col">Apellido</th>
                                            <th scope="col">Cédula</th>
                                            <th scope="col">Estado trámite</th>
                                            <th scope="col">Radicado</th>
                                            <th scope="col">Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{data?.primer_nombre}</td>
                                            <td>{data?.primer_apellido}</td>
                                            <td>{data?.numero_documento}</td>
                                            <td>
                                                {
                                                    data?.solicitud[0]
                                                        .estado_solicitud.nombre
                                                }
                                            </td>
                                            <td>
                                                {
                                                    data?.solicitud[0]
                                                        .id_radicado_orfeo
                                                }
                                            </td>
                                            <td>
                                                <Link to={`/realizar-tramite`}>
                                                    <button
                                                        className="btn btn-round btn-high"
                                                        disabled={
                                                            data?.solicitud[0]
                                                                .estado_solicitud
                                                                .nombre !==
                                                                "DEVUELTA" &&
                                                            data?.solicitud[0]
                                                                .estado_solicitud
                                                                .nombre !==
                                                                "CREADA"
                                                        }
                                                        onClick={() =>
                                                            localStorage.setItem(
                                                                "isEdit",
                                                                true
                                                            )
                                                        }
                                                    >
                                                        Editar
                                                    </button>
                                                </Link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                {data.datos_nota ? (
                                    <div>
                                        <h2>Observaciones de su solicitud</h2>
                                        <p
                                            className="text-justify"
                                            dangerouslySetInnerHTML={{
                                                __html: data.datos_nota
                                                    .observacion,
                                            }}
                                        />
                                    </div>
                                ) : (
                                    ""
                                )}
                                {data.datos_devolucion ? (
                                    <div>
                                        <h2>Causales de devolución</h2>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        Causales
                                                    </th>
                                                    <th scope="col">
                                                        Descripcion
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.datos_devolucion.map(
                                                    function (nextItem, j) {
                                                        return (
                                                            <tr
                                                                key={nextItem.j}
                                                            >
                                                                <td>
                                                                    {
                                                                        nextItem
                                                                            .causal_devolucion
                                                                            .nombre_documento
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        nextItem
                                                                            .causal_devolucion
                                                                            .causal_devolucion
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    ""
                                )}

                                <h2>Archivos cargados</h2>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Archivo</th>
                                            <th scope="col">ID Radicado</th>
                                            <th scope="col">Documento</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.datos_archivos.map(function (
                                            nextItem,
                                            j
                                        ) {
                                            let file = nextItem.ruta_archivo;
                                            let url = `${API_URL}/solicitudes/descargar-archivo/${base64_encode(
                                                file
                                            )}`;
                                            // console.log(url)

                                            return (
                                                <tr key={nextItem.j}>
                                                    <td>
                                                        {
                                                            nextItem
                                                                .tipo_archivo
                                                                .detalle
                                                        }
                                                    </td>
                                                    <td>
                                                        {nextItem.anexo_codigo}
                                                    </td>
                                                    <td>
                                                        <a
                                                            rel="noreferrer"
                                                            class="btn btn-round btn-high boton-inicio"
                                                            href={url}
                                                            target="_blank"
                                                        >
                                                            Descargar
                                                        </a>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </>
                        ) : (
                            show &&
                            !data && (
                                <>
                                    <h4>
                                        El número de documento no tiene una
                                        solicitud activa.
                                    </h4>
                                </>
                            )
                        )}
                    </div>
                    <div className="col-lg-1 mt-5"></div>
                    <div className="col-lg-3 mt-5">
                        <div className="gov-co-servi">
                            <component-doubts-contact
                                email="ayuda@scrd.gov.co"
                                phone="(601) 327 48 50"
                                faq="test"
                                adicionales='[
              {
                  "title": "Atención Presencial",
                  "value": "Carrera 8 No 9-83 de lunes a viernes en Jornada continua de 7:30 a.m. a 4;30 p.m"
              }
          ]'
                                className="d-flex justify-content-end"
                            ></component-doubts-contact>
                            <component-qualify-procedure
                                className="d-flex justify-content-end"
                                fullscreen="false"
                            ></component-qualify-procedure>
                        </div>
                    </div>
                </div>
            </div>
            <govco-footer
                color_fondo="#5d4293"
                titulo_entidad="Secretaría de Cultura, Recreación y Deporte"
                url_logo="https://www.culturarecreacionydeporte.gov.co/sites/default/files/2022-08/Logo-secretaria-cultura-recreacion-deporte-morado.svg"
                url_redirect_logo="https://www.culturarecreacionydeporte.gov.co/"
                alt_url_logo="Logo de la Secretaría de Cultura, Recreación y Deporte"
                description_Logo="Logo de la Secretaría de Cultura, Recreación y Deporte"
                direccion="Cra 8 # 9 - 83, Bogotá - Colombia"
                codigo_postal="111711"
                conmutador="(601) 327 48 50"
                horario_atencion="Lunes a viernes 7:30 a.m. a 4:30 p.m."
                correo_entidad="correspondencia.externa@scrd.gov.co"
                cuenta_twiter="CulturaenBta"
                cuenta_instagram="culturaenbta"
                cuenta_facebook="CulturaenBogota"
                politicas="https://www.culturarecreacionydeporte.gov.co/es/politica-de-privacidad"
                mapa_sitio="https://www.culturarecreacionydeporte.gov.co/sitemap"
                terminos_condiciones="#"
            ></govco-footer>
        </div>
    );
};

export default ConsultarTramite;
